module.exports = __webpack_public_path__ + "img/Réalisation portail selon plan client.0c5c0deb.jpg";